export const ACCOUNT_USAGE_LINK = {
    href: '/app/settings/billing',
    icon: { selected: 'miscWallet', unselected: 'miscWallet' },
    text: 'Usage',
};
export const FALLBACK_SIDEBAR_RESPONSE = {
    itemGroups: [
        [
            {
                href: '/app/dashboard',
                icon: 'navHome',
                iconFilled: 'navHomeFill',
                text: 'Home',
            },
        ],
        [
            {
                href: '/app/zaps',
                icon: 'miscBoltAltFill',
                iconFilled: 'miscBoltAltFill',
                text: 'Zaps',
            },
            {
                href: `https://tables.zapier.com/app/tables?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier`,
                icon: 'navTables',
                iconFilled: 'navTables',
                text: 'Tables',
            },
            {
                href: `https://interfaces.zapier.com/interfaces?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier/`,
                icon: 'navInterfacesV2',
                iconFilled: 'navInterfacesV2',
                text: 'Interfaces',
            },
            {
                href: '/app/chatbots',
                text: 'Chatbots',
                icon: 'navChatbots',
                iconFilled: 'navChatbots',
                tag: 'Beta',
            },
            {
                href: '/app/canvas',
                text: 'Canvas',
                icon: 'navCanvasV2',
                iconFilled: 'navCanvasV2',
                tag: 'Beta',
            },
        ],
        [
            {
                href: '/app/connections',
                icon: 'navApps',
                iconFilled: 'navAppsFill',
                text: 'Apps',
            },
            {
                href: '/app/history',
                icon: 'miscClock',
                iconFilled: 'miscClockFill',
                text: 'Zap History',
            },
        ],
    ],
};
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
